// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Bm2e","question":"Question_question__3dF5b","description":"Question_description__2Y6PX"};